import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import './Login.css';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { Kinde } from 'services/AuthService';
import { GetMySettings } from '../../services/UsersService';

export default function Login(): JSX.Element {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const returnUrl = searchParams.get('return-url');
  const navigate = useNavigate();
  const { login, getToken, isAuthenticated } = useKindeAuth();

  useEffect(() => {
    const fetchToken = async () => {
      if (isAuthenticated) {
        // @ts-expect-error Annoying
        const t = await getToken();

        // @ts-expect-error Annoying
        const data = await Kinde(t);

        if (data) {
          await GetMySettings();

          const redirectUrl = localStorage.getItem('redirect-url');
          localStorage.setItem('redirect-url', '');

          if (redirectUrl && redirectUrl?.indexOf('api/connect/') >= 0) {
            window.location.replace(redirectUrl);
          } else {
            if (redirectUrl != null && redirectUrl !== '') {
              navigate(redirectUrl);
            } else {
              navigate('/home');
            }
          }
        }
      } else if (!code) {
        if (returnUrl != null && returnUrl !== '') {
          localStorage.setItem('redirect-url', returnUrl);
        }
        login();
      }
    };

    fetchToken();
  }, [isAuthenticated, login, returnUrl]);

  const [showLoading] = useState(true);

  return (
    <>
      <Backdrop open={showLoading} sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
        <CircularProgress sx={{ color: 'text.disabled' }} />
      </Backdrop>
      <Box display="flex" flex="1 0 0">
        <Box bgcolor="primary.main" flex="1 0 0">
          <Box display="flex" height="100%" justifyContent="center" alignItems="center"></Box>
        </Box>
      </Box>
    </>
  );
}
